"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localizeLabelableContentType = exports.localizeLabelCategory = exports.buildLineagePath = exports.useExpand = exports.groupLabelsByType = exports.groupBy = exports.assetTableauIconForType = exports.assetIconForType = exports.useLabelPopoverDetails = exports.LabelPopoverDetailsContext = exports.LabelsPopoverContext = exports.buildLabelsPopoverContext = exports.LabelButtonContext = exports.defaultLabelRenderControls = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_icons_1 = require("@tableau/catalog-icons");
const catalog_messages_1 = require("@tableau/catalog-messages");
const DatasourceCanBaseIcon_1 = require("@tableau/icons/DatasourceCanBaseIcon");
const DatasourceServerBaseIcon_1 = require("@tableau/icons/DatasourceServerBaseIcon");
const DatasourceServerConnectionBaseIcon_1 = require("@tableau/icons/DatasourceServerConnectionBaseIcon");
const DatasourceTableBaseIcon_1 = require("@tableau/icons/DatasourceTableBaseIcon");
const DatasourceTableConnectionIcon_1 = require("@tableau/icons/DatasourceTableConnectionIcon");
const FileBaseIcon_1 = require("@tableau/icons/FileBaseIcon");
const FlowBaseIcon_1 = require("@tableau/icons/FlowBaseIcon");
const react_1 = tslib_1.__importDefault(require("react"));
const RemoteTypeIcon_1 = require("../dataGrid/cellFormatters/RemoteTypeIcon");
const LabelValueSorting_1 = require("./LabelValueSorting");
exports.defaultLabelRenderControls = {
    siteUrls: catalog_core_1.noopSiteUrls,
    linksDisabled: true,
    kind: 'chip',
    popoverPlacement: 'bottom-start',
    hidePopoverWhenReferenceIsHidden: true,
};
exports.LabelButtonContext = react_1.default.createContext(exports.defaultLabelRenderControls);
function buildLabelsPopoverContext(props) {
    var _a, _b, _c, _d, _e, _f;
    const totalUpstream = props.categoryType === 'warning' || props.categoryType === 'sensitivity' || props.categoryType === 'custom'
        ? (_b = (_a = props.upstream) === null || _a === void 0 ? void 0 : _a.labels.length) !== null && _b !== void 0 ? _b : 0
        : 0;
    const totalParented = (_d = (_c = props.parented) === null || _c === void 0 ? void 0 : _c.labels.length) !== null && _d !== void 0 ? _d : 0;
    const totalAnchored = (_f = (_e = props.anchored) === null || _e === void 0 ? void 0 : _e.labels.length) !== null && _f !== void 0 ? _f : 0;
    const totalLabels = totalUpstream + totalParented + totalAnchored;
    let collapse = 'disallow';
    if (totalLabels > 1 && totalLabels <= 3) {
        collapse = 'allow';
    }
    else if (totalLabels > 3) {
        collapse = 'prefer';
    }
    return { collapse, content: props.content, category: props.category, categoryType: props.categoryType };
}
exports.buildLabelsPopoverContext = buildLabelsPopoverContext;
exports.LabelsPopoverContext = react_1.default.createContext({
    collapse: 'allow',
    category: 'warning',
    categoryType: 'warning',
});
exports.LabelPopoverDetailsContext = react_1.default.createContext({ categories: {}, values: {} });
function useLabelPopoverDetails() {
    return react_1.default.useContext(exports.LabelPopoverDetailsContext);
}
exports.useLabelPopoverDetails = useLabelPopoverDetails;
function assetIconForType(type, remoteType) {
    switch (type) {
        case null:
            return null;
        case 'CloudFile':
        case 'File':
            return react_1.default.createElement(catalog_icons_1.SvgSpacesMediumFile, null);
        case 'database':
        case 'DatabaseServer':
        case 'WebDataConnector':
            return react_1.default.createElement(catalog_icons_1.SvgSpacesMediumExternalServer, null);
        case 'table':
        case 'DatabaseTable':
        case 'CalculatedInsight':
        case 'DataLake':
        case 'DataModel':
            return react_1.default.createElement(catalog_icons_1.SvgSpacesMediumTable, null);
        case 'Flow':
        case 'flow':
            return react_1.default.createElement(catalog_icons_1.SvgSpacesMediumFlow, null);
        case 'datasource':
        case 'PublishedDatasource':
        case 'EmbeddedDatasource':
            return react_1.default.createElement(catalog_icons_1.SvgSpacesMediumDs, null);
        case 'column':
        case 'Column':
            return remoteType ? react_1.default.createElement(RemoteTypeIcon_1.RemoteTypeIcon, { remoteType: remoteType }) : null;
        case 'VirtualConnection':
        case 'virtualConnection':
            return react_1.default.createElement(catalog_icons_1.SvgVirtualConnection, null);
        case 'VirtualConnectionTable':
        case 'virtualConnectionTable':
            return react_1.default.createElement(catalog_icons_1.SvgVirtualConnectionTable, null);
        case 'Field':
            return remoteType ? react_1.default.createElement(RemoteTypeIcon_1.RemoteTypeIcon, { remoteType: remoteType }) : null;
        case 'View':
        case 'Metric':
        case 'Workbook':
            return null;
        default:
            (0, catalog_core_1.assertUnreachable)(type);
            return null;
    }
}
exports.assetIconForType = assetIconForType;
function assetTableauIconForType(type, remoteType, size) {
    switch (type) {
        case null:
            return null;
        case 'CloudFile':
        case 'File':
            return react_1.default.createElement(FileBaseIcon_1.FileBaseIcon, { size: size !== null && size !== void 0 ? size : 14 });
        case 'database':
        case 'DatabaseServer':
        case 'WebDataConnector':
            return react_1.default.createElement(DatasourceServerBaseIcon_1.DatasourceServerBaseIcon, { size: 14 });
        case 'table':
        case 'DatabaseTable':
        case 'CalculatedInsight':
        case 'DataLake':
        case 'DataModel':
            return react_1.default.createElement(DatasourceTableBaseIcon_1.DatasourceTableBaseIcon, { size: 14 });
        case 'Flow':
        case 'flow':
            return react_1.default.createElement(FlowBaseIcon_1.FlowBaseIcon, { size: 14 });
        case 'datasource':
        case 'PublishedDatasource':
        case 'EmbeddedDatasource':
            return react_1.default.createElement(DatasourceCanBaseIcon_1.DatasourceCanBaseIcon, { size: size !== null && size !== void 0 ? size : 14 });
        case 'column':
        case 'Column':
            return remoteType ? react_1.default.createElement(RemoteTypeIcon_1.RemoteTypeIcon, { remoteType: remoteType }) : null;
        case 'VirtualConnection':
        case 'virtualConnection':
            return react_1.default.createElement(DatasourceServerConnectionBaseIcon_1.DatasourceServerConnectionBaseIcon, { size: 14 });
        case 'VirtualConnectionTable':
        case 'virtualConnectionTable':
            return react_1.default.createElement(DatasourceTableConnectionIcon_1.DatasourceTableConnectionIcon, { size: 14 });
        case 'Field':
            return remoteType ? react_1.default.createElement(RemoteTypeIcon_1.RemoteTypeIcon, { remoteType: remoteType }) : null;
        case 'View':
        case 'Metric':
        case 'Workbook':
            return null;
        default:
            (0, catalog_core_1.assertUnreachable)(type);
            return null;
    }
}
exports.assetTableauIconForType = assetTableauIconForType;
// TODO: refactor to use groupByToMultimap
const groupBy = (arr, key) => arr.reduce((groups, item) => {
    var _a;
    const k = key(item);
    !groups.has(k) ? groups.set(k, [item]) : (_a = groups.get(k)) === null || _a === void 0 ? void 0 : _a.push(item);
    return groups;
}, new Map());
exports.groupBy = groupBy;
function groupLabelsByType(labels) {
    return Array.from((0, exports.groupBy)(labels, i => { var _a; return (_a = i.labels[0].type) !== null && _a !== void 0 ? _a : ''; }).values()).sort((a, b) => (0, LabelValueSorting_1.sortLabelValues)({
        category: a[0].category,
        value: a[0].labels[0].type,
    }, {
        category: b[0].category,
        value: b[0].labels[0].type,
    }));
}
exports.groupLabelsByType = groupLabelsByType;
function useExpand(overrides) {
    const { collapse } = react_1.default.useContext(exports.LabelsPopoverContext);
    const [isExpanded, setIsExpanded] = react_1.default.useState(() => {
        var _a;
        switch ((_a = overrides === null || overrides === void 0 ? void 0 : overrides.collapse) !== null && _a !== void 0 ? _a : collapse) {
            case 'disallow':
            case 'allow':
                return true;
            case 'prefer':
                return false;
        }
    });
    return [isExpanded, setIsExpanded];
}
exports.useExpand = useExpand;
function buildLineagePath(siteUrls, source, vizportalUrlId) {
    switch (source) {
        case 'datasource':
        case 'EmbeddedDatasource':
        case 'PublishedDatasource':
            return siteUrls.datasourceLineageFieldsUrl(vizportalUrlId);
        case 'flow':
        case 'Flow':
            return siteUrls.flowLineageFieldsUrl(vizportalUrlId);
        case 'virtualConnectionTable':
        case 'VirtualConnectionTable':
            return siteUrls.virtualConnectionTableLineageFieldsUrl(vizportalUrlId);
        case 'workbook':
        case 'Workbook':
            return siteUrls.workbookLineageFieldsUrl(vizportalUrlId);
        default:
            return '';
    }
}
exports.buildLineagePath = buildLineagePath;
function localizeLabelCategory(category) {
    switch (category) {
        case 'CERTIFICATION':
            return catalog_messages_1.Messages.Certification();
        case 'SENSITIVITY':
            return catalog_messages_1.Messages.ColumnHeaderSensitivity();
        case 'WARNING':
            return catalog_messages_1.Messages.DataQualityWarningTitle();
        default:
            return category;
    }
}
exports.localizeLabelCategory = localizeLabelCategory;
function localizeLabelableContentType(contentType) {
    switch (contentType) {
        case 'column':
            return catalog_messages_1.Messages.column_lower();
        case 'database':
            return catalog_messages_1.Messages.database_lower();
        case 'datasource':
            return catalog_messages_1.Messages.datasource_lower();
        case 'flow':
            return catalog_messages_1.Messages.flow_lower();
        case 'table':
        case 'tableWithCrass':
            return catalog_messages_1.Messages.table_lower();
        case 'virtualConnection':
            return catalog_messages_1.Messages.virtualConnection_lower();
        case 'virtualConnectionTable':
            return catalog_messages_1.Messages.virtualConnectionTableLower();
        default:
            return '';
    }
}
exports.localizeLabelableContentType = localizeLabelableContentType;
//# sourceMappingURL=LabelHelpers.js.map